module.exports = __webpack_public_path__ + "img/14.fc13153c.png";